export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-minus-c2d0bcd549b9d4afca1df6e817b33092.svg";